import React from 'react';
import { createPortal } from 'react-dom';
import './GiphyModal.css';
import GifPicker from '../GifPicker/GifPicker';

interface GiphyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (gifUrl: string) => void;
}

const GiphyModal: React.FC<GiphyModalProps> = ({ isOpen, onClose, onSelect }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div className="giphy-modal-overlay" onClick={handleOverlayClick}>
      <div className="giphy-modal-content" onClick={e => e.stopPropagation()}>
        <div className="giphy-modal-header">
          <h2>Choose GIF</h2>
          <button className="cancel-button" onClick={onClose}>Cancel</button>
        </div>
        <div className="giphy-modal-body">
          <GifPicker onSelect={onSelect} onClose={onClose} />
        </div>
      </div>
    </div>,
    document.getElementById('giphy-modal-root') || document.body
  );
};

export default GiphyModal;
